import ComingSoon from "@/components/ComingSoon";

export default function AnalyticsDashboard() {
  return <ComingSoon featureName="Analytics Dashboard" description="Page views, user sessions, and action tracking. This feature requires backend Analytics/Telemetry APIs." />;
}
